import { message } from 'antd';
import React, { useMemo, useState } from 'react';
import Compress from 'react-image-file-resizer';
import { useHistory } from 'react-router-dom';
import { errorHandler } from '../utils';
import { instanceRef } from '../utils/axios';

const SiniestroContext = React.createContext({});

export function SiniestroProvider(props) {
  const history = useHistory();
  const [datosAsegurado, setDatosAsegurado] = useState(null);
  const [datosSiniestro, setDatosSiniestro] = useState({});
  const [loading, setLoading] = useState(true);
  const [loadingSpin, setLoadingSpin] = useState(false);
  const [images, setImages] = useState([]);
  const [hasImagenes, setHasImagenes] = useState(false);
  const [loadingImages, setLoadingImages] = useState(false);
  const [documentosAdicionales, setDocumentosAdicionales] = useState([]);
  const [habilitacion1, setHabilitacion1] = useState('');
  const [habilitacion2, setHabilitacion2] = useState('');
  const [registro1, setRegistro1] = useState('');
  const [registro2, setRegistro2] = useState('');
  const [cedula1, setCedula1] = useState('');
  const [cedula2, setCedula2] = useState('');
  const [cedulaVerde1, setCedulaVerde1] = useState('');
  const [cedulaVerde2, setCedulaVerde2] = useState('');
  const [documento1, setDocumento1] = useState('');
  const [partePolicialDoc, setPartePolicialDoc] = useState('');
  const [comentario, setComentario] = useState('');

  const sendEmail = async () => {
    try {
      const data = {
        token: datosSiniestro.token,
        url: `${window.location.origin}/siniestros/form/${datosSiniestro.token}/desktop`
      };
      message.info(
        `${datosSiniestro.poliza.solicitud.cotizacion.persona.correo} recibirá un correo con el enlace de inspección`
      );
      await instanceRef.instance.post(`siniestro/email`, data);
      history.push('/');
    } catch (error) {
      // error
    }
  };

  const getSiniestro = async (token) => {
    try {
      setLoading(true);
      setLoadingSpin(true);
      const response = await instanceRef.instance.get(`/siniestro/${token}`);
      setDatosSiniestro(response.data.data);
      getImages(response.data.data);
      setComentario(response.data.data.comentario);
      setLoading(false);
      setLoadingSpin(false);
      return response.data.data;
    } catch (error) {
      setLoading(false);
      setLoadingSpin(false);
      errorHandler(error, 'Error al obtener los datos');
    }
    return {};
  };

  function setHasImagenesFunction(hasImagenesParam) {
    setHasImagenes(hasImagenesParam);
  }

  const updateSiniestro = async (data) => {
    try {
      const response = await instanceRef.instance.put(
        `/siniestro/${datosSiniestro.token}`,
        data
      );
      return response.data.data;
    } catch (error) {
      //
    }
    return {};
  };

  const uploadDocumentos = async (siniestro) => {
    const docs = documentosAdicionales.filter((e) => e.nombre);
    try {
      const datos = {
        empresa:
          siniestro.poliza.solicitud.cotizacion.aseguradoraEmpresa.empresa
            .nombre,
        aseguradora:
          siniestro.poliza.solicitud.cotizacion.aseguradoraEmpresa.aseguradora
            .desc,
        nombres: siniestro.poliza?.solicitud?.cotizacion?.persona.nombres,
        tipoProducto: siniestro.poliza.producto.descripcion,
        id: siniestro.id,
        token: siniestro.token
      };

      if (cedula1 && cedula1.nombre) docs.push(cedula1);
      if (cedula2 && cedula2.nombre) docs.push(cedula2);
      if (cedulaVerde1 && cedulaVerde1.nombre) docs.push(cedulaVerde1);
      if (cedulaVerde2 && cedulaVerde2.nombre) docs.push(cedulaVerde2);
      if (registro1 && registro1.nombre) docs.push(registro1);
      if (registro2 && registro1.nombre) docs.push(registro2);
      if (habilitacion1 && habilitacion1.nombre) docs.push(habilitacion1);
      if (habilitacion2 && habilitacion2.nombre) docs.push(habilitacion2);
      if (documento1 && documento1.nombre) docs.push(documento1);
      if (partePolicialDoc && partePolicialDoc.nombre)
        docs.push(partePolicialDoc);

      const data = { files: docs, data: datos };
      const response = await instanceRef.instance.post(
        `siniestro/upload-documentos`,
        data,
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
      return response;
    } catch (error) {
      errorHandler(error, 'Error al subir los archivos');
      return false;
    }
  };

  const validateStep = (producto) => {
    if (producto === 1 || producto === 7) {
      if (!cedula1 || !cedula2) {
        message.warning('Debe cargar su cédula de identidad (ambos lados)');

        return false;
      }
      if (!cedulaVerde1 || !cedulaVerde2) {
        message.warning('Debe cargar la cédula verde (ambos lados)');

        return false;
      }
      if (!habilitacion1 || !habilitacion2) {
        message.warning('Debe cargar la habilitación (ambos lados)');

        return false;
      }
      if (!registro1 || !registro2) {
        message.warning('Debe cargar el registro de conducir (ambos lados)');

        return false;
      }
    }
    if (producto === 2 || producto === 3) {
      if (!cedula1 || !cedula2) {
        message.warning('Debe cargar su cédula de identidad (ambos lados)');

        return false;
      }
      if (!documento1) {
        message.warning(
          'Debe cargar Factura de gasots y/o Informe/Estudios médicos'
        );
        return false;
      }
    }
    if (producto === 4 || producto === 5 || producto === 6) {
      if (!documento1) {
        message.warning(
          'Debe cargar Facturas o Presupuesto de Reparación Daños/Reposición de Bienes'
        );
        return false;
      }
    }
    return true;
  };

  const eliminarAdicional = async (siniestro, paso) => {
    setLoading(true);
    try {
      const response = await instanceRef.instance.post(
        `/siniestro/archivos/update`,
        {
          params: {
            siniestroId: siniestro.id,
            type: 'd',
            pasoNro: paso,
            url: true,
            marked: false,
            base64: false,
            imgcompress: true,
            eliminado: true
          }
        }
      );
      getImages(siniestro);
      setLoading(false);
      return response.data.data;
    } catch (error) {
      setLoading(false);
      // console.log(error);
    }
    return {};
  };

  const deleteFile = (index) => {
    let docs = documentosAdicionales;
    if (documentosAdicionales[index].id) {
      // eliminar archivo adcional de base
      eliminarArchivoAdicional(documentosAdicionales[index].id);
    }
    if (index === docs.length - 1) {
      // Eliminar de state de documentos adicionales
      if (documentosAdicionales[index].id) {
        docs = docs.filter(
          (e) =>
            !e.descripcion.includes(documentosAdicionales[index].descripcion)
        );
      } else {
        docs = docs.filter(
          (e) => !e.nombre.includes(documentosAdicionales[index].nombre)
        );
      }
    } else {
      for (let i = index + 1; i < docs.length; i += 1) {
        docs[i - 1] = docs[i];
      }
      docs.pop();
    }
    setDocumentosAdicionales(docs);
  };

  const eliminarArchivoAdicional = async (id) => {
    setLoading(true);
    try {
      const response = await instanceRef.instance.put(`/siniestro/file`, {
        idArchivo: id
      });
      return response.data.data;
    } catch (error) {
      // console.log(error);
    }
    setLoading(false);
    return {};
  };

  const getImages = async (siniestro) => {
    try {
      setLoadingImages(true);
      const response = await instanceRef.instance.get(`/archivos/`, {
        params: {
          filter: {
            id: siniestro.id,
            token: siniestro.token,
            type: 'd',
            url: true,
            marked: false,
            base64: false,
            imgcompress: true
          }
        }
      });
      // setImages(response.data.data);
      if (response.data?.data) {
        setImages([...images, response.data.data[0]]);
      }
      setLoadingImages(false);
      return response.data.data;
    } catch (error) {
      // error
    }
    setLoadingImages(false);
    return {};
  };

  const uploadView = async (file, pasoNro, siniestro, parte) => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append(
        'empresa',
        siniestro.poliza.solicitud.cotizacion.aseguradoraEmpresa.empresa.nombre
      );
      formData.append(
        'aseguradora',
        siniestro.poliza.solicitud.cotizacion.aseguradoraEmpresa.aseguradora
          .desc
      );
      formData.append(
        'nombres',
        `${siniestro.poliza?.solicitud?.cotizacion?.persona.nombres}`
      );
      formData.append('tipo_producto', siniestro.poliza.producto.descripcion);
      formData.append('id', siniestro.id);
      formData.append('token', siniestro.token);
      formData.append('paso_nro', pasoNro);
      formData.append('type', 'd');
      formData.append('imgcompress', true);
      if (parte) {
        formData.append('parte', parte);
      }
      const response = await instanceRef.instance.post(
        `siniestro/imgcompress`,
        formData,
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }
      );
      return response;
    } catch (error) {
      errorHandler(error, 'Error al subir el archivo');
      return false;
    }
  };

  const uploadFile = async (file, pasoNro, siniestro, parte) => {
    setHasImagenesFunction(true);
    if (
      datosSiniestro &&
      Object.keys(datosSiniestro).length === 0 &&
      datosSiniestro.constructor === Object
    ) {
      try {
        const formData = new FormData();
        formData.append('file', file);
        formData.append(
          'empresa',
          siniestro.poliza.solicitud.cotizacion.aseguradoraEmpresa.empresa
            .nombre
        );
        formData.append(
          'aseguradora',
          siniestro.poliza.solicitud.cotizacion.aseguradoraEmpresa.aseguradora
            .desc
        );
        formData.append(
          'nombres',
          `${siniestro.poliza?.solicitud?.cotizacion?.persona.nombres}`
        );
        formData.append('tipo_producto', siniestro.poliza.producto.descripcion);
        formData.append('id', siniestro.id);
        formData.append('token', siniestro.token);
        formData.append('paso_nro', pasoNro);
        formData.append('type', 'd');
        formData.append('imgcompress', false);
        if (parte) {
          formData.append('parte', parte);
        }

        const response = await instanceRef.instance.post(
          `siniestro/upload`,
          formData,
          {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          }
        );
        await Compress.imageFileResizer(
          file, // the file from input
          480, // width
          480, // height
          'JPEG', // compress format WEBP, JPEG, PNG
          70, // quality
          0, // rotation
          (uri) => {
            uploadView(uri, pasoNro, siniestro, parte);
          },
          'blob' // blob or base64 default base64
        );
        await updateSiniestro({
          etapa: 'INICIADA',
          estado: 'DENUNCIA',
          latitud: siniestro.latitud,
          longitud: siniestro.longitud
        });
        return response;
      } catch (error) {
        errorHandler(error, 'Error al subir el archivo');
        return false;
      }
    } else {
      try {
        const formData = new FormData();
        formData.append('file', file);
        formData.append(
          'empresa',
          siniestro.poliza.solicitud.cotizacion.aseguradoraEmpresa.empresa
            .nombre
        );
        formData.append(
          'aseguradora',
          siniestro.poliza.solicitud.cotizacion.aseguradoraEmpresa.aseguradora
            .desc
        );
        formData.append(
          'nombres',
          `${siniestro.poliza?.solicitud?.cotizacion?.persona.nombres}`
        );
        formData.append('tipo_producto', siniestro.poliza.producto.descripcion);
        formData.append('id', siniestro.id);
        formData.append('token', siniestro.token);
        formData.append('paso_nro', pasoNro);
        formData.append('type', 'd');
        formData.append('imgcompress', false);
        if (parte) {
          formData.append('parte', parte);
        }

        const response = await instanceRef.instance.post(
          `siniestro/upload`,
          formData,
          {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          }
        );
        await Compress.imageFileResizer(
          file, // the file from input
          480, // width
          480, // height
          'JPEG', // compress format WEBP, JPEG, PNG
          70, // quality
          0, // rotation
          (uri) => {
            uploadView(uri, pasoNro, siniestro, parte);
          },
          'blob' // blob or base64 default base64
        );
        await updateSiniestro({
          estado: 'DENUNCIA',
          etapa: 'INICIADA',
          latitud: siniestro.latitud,
          longitud: siniestro.longitud
        });

        return response;
      } catch (error) {
        errorHandler(error, 'Error al subir el archivo');
        return false;
      }
    }
  };

  const value = useMemo(() => {
    return {
      loadingImages,
      loading,
      images,
      hasImagenes,
      uploadDocumentos,
      setHasImagenesFunction,
      getImages,
      getSiniestro,
      uploadFile,
      setLoading,
      datosAsegurado,
      setDatosAsegurado,
      datosSiniestro,
      setDatosSiniestro,
      documentosAdicionales,
      setDocumentosAdicionales,
      eliminarAdicional,
      validateStep,
      habilitacion1,
      setHabilitacion1,
      habilitacion2,
      setHabilitacion2,
      cedula1,
      setCedula1,
      cedula2,
      setCedula2,
      cedulaVerde1,
      setCedulaVerde1,
      cedulaVerde2,
      setCedulaVerde2,
      registro1,
      setRegistro1,
      registro2,
      setRegistro2,
      comentario,
      setComentario,
      documento1,
      setDocumento1,
      partePolicialDoc,
      setPartePolicialDoc,
      updateSiniestro,
      loadingSpin,
      setLoadingSpin,
      sendEmail,
      deleteFile,
      eliminarArchivoAdicional
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    loading,
    loadingSpin,
    images,
    hasImagenes,
    documentosAdicionales,
    cedula1,
    cedula2,
    cedulaVerde1,
    cedulaVerde2,
    habilitacion1,
    habilitacion2,
    registro1,
    registro2,
    partePolicialDoc,
    comentario,
    documento1
  ]);
  return <SiniestroContext.Provider value={value} {...props} />;
}

export function useSiniestroContext() {
  const context = React.useContext(SiniestroContext);
  if (!context) {
    throw new Error('useSiniestroContext debe estar dentro del Proveedor ');
  }
  return context;
}
